module.exports = __webpack_public_path__ + "public/Icons/assignDriver.svg?e4fc2309";